import React from "react";
import MobileAppDropdown from "../../global/mobileAppDropdown";
import MobileAppShowcase from "../../global/mobileAppShowcase";
import ContentPreview from "../../global/contentPreview";
import BusinessSection from "../../global/businessSection";
import PersonaSection from "../../global/personaSection";
import BecomeAPartner from "../../global/becomeAPartner";
import TermsAndConditions from "../../global/termsAndConditions";
import DownloadApp from "../../global/downloadApp";
import DoctorCondition from "../../global/doctorCondition";

const renderComponent = component => {
  switch (component.sectionType) {
    case "persona":
      return <PersonaSection content={component} />;
    case "seeADoctor":
      return <DoctorCondition content={component} />;
    case "business":
      return <BusinessSection content={component} />;
    case "contentPreview":
      return <ContentPreview content={component} />;
    case "mobileAppDropdown":
      return <MobileAppDropdown content={component} />;
    case "mobileAppShowcase":
      return <MobileAppShowcase content={component} />;
    case "joinUs":
      return <BecomeAPartner content={component} />;
    case "termsConditions":
      return <TermsAndConditions content={component} />;
    case "getTheApp":
      return <DownloadApp content={component} />;
    default:
      return null;
  }
};

export default function PageSection({ component, isMobile }) {
  return renderComponent(component, isMobile);
}
